import { render, staticRenderFns } from "./NoFilter.vue?vue&type=template&id=28a136e8&"
import script from "./NoFilter.vue?vue&type=script&lang=js&"
export * from "./NoFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Pipelines\\release\\06.04\\maintenance\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28a136e8')) {
      api.createRecord('28a136e8', component.options)
    } else {
      api.reload('28a136e8', component.options)
    }
    module.hot.accept("./NoFilter.vue?vue&type=template&id=28a136e8&", function () {
      api.rerender('28a136e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/Wes/NoFilter.vue"
export default component.exports